import { render } from "./realtime_public.vue?vue&type=template&id=c07f9ebe&scoped=true"
import script from "./realtime_public.vue?vue&type=script&lang=js"
export * from "./realtime_public.vue?vue&type=script&lang=js"

import "./realtime_public.vue?vue&type=style&index=0&id=c07f9ebe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c07f9ebe"]])

export default __exports__